var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "520" },
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.close($event)
        }
      },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("provisionBatch.details.reportDialog.title")) +
                  " "
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("p", { staticClass: "subtitle-2 mb-3" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("provisionBatch.details.reportDialog.selectAreas")
                  )
                )
              ]),
              _c("v-checkbox", {
                staticClass: "mt-0 mb-1",
                attrs: {
                  label: _vm.$t(
                    "provisionBatch.details.reportDialog.selectAll"
                  ),
                  dense: "",
                  "hide-details": ""
                },
                on: { change: _vm.toggleAll },
                model: {
                  value: _vm.allSelected,
                  callback: function($$v) {
                    _vm.allSelected = $$v
                  },
                  expression: "allSelected"
                }
              }),
              _c("v-divider", { staticClass: "mb-2" }),
              _vm._l(_vm.availableAreas, function(area) {
                return _c("v-checkbox", {
                  key: area,
                  staticClass: "mt-0",
                  attrs: {
                    value: area,
                    label: area,
                    dense: "",
                    "hide-details": ""
                  },
                  model: {
                    value: _vm.selected,
                    callback: function($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected"
                  }
                })
              }),
              _vm.selected.length === 0
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-3 mb-0",
                      attrs: { type: "warning", text: "", dense: "" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "provisionBatch.details.reportDialog.noAreasSelected"
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                : _vm._e(),
              _c("v-text-field", {
                staticClass: "mt-4 mb-0",
                attrs: {
                  label: _vm.$t(
                    "provisionBatch.details.reportDialog.reportReference"
                  ),
                  outlined: "",
                  dense: "",
                  clearable: "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.reference,
                  callback: function($$v) {
                    _vm.reference = $$v
                  },
                  expression: "reference"
                }
              })
            ],
            2
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c("v-btn", { attrs: { text: "" }, on: { click: _vm.close } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("provisionBatch.details.reportDialog.cancel")
                    ) +
                    " "
                )
              ]),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: _vm.selected.length === 0
                  },
                  on: { click: _vm.generate }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-file-document-outline")
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("provisionBatch.details.reportDialog.generate")
                      ) +
                      " "
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }